import { TESTIMONIALS } from "../lib/content";
import { Reveal, MaskText } from "../components/Motion";

export const Testimonials = () => (
  <section data-testid="testimonials" className="bg-paper py-24 md:py-40">
    <div className="max-w-[1500px] mx-auto px-5 md:px-10">
      <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
        <Reveal><p className="text-sand-deep text-[11px] uppercase tracking-[0.3em] mb-6">Kind words</p></Reveal>
        <MaskText as="h2" className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-ink" lines={["What my lovely", "couples have to say . . ."]} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-ink/10 border border-ink/10">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 2) * 0.1} className="bg-paper">
            <figure className="p-9 md:p-14 h-full flex flex-col justify-between">
              <blockquote className="font-serif text-2xl md:text-3xl leading-snug text-ink italic">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-3">
                <span className="w-8 h-px bg-sand-deep" />
                <span className="text-[11px] uppercase tracking-[0.2em] text-ink-soft">{t.name} · {t.venue}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
